import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-mission-selection',
    templateUrl: './mission-selection.component.html',
    styleUrls: ['./mission-selection.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MissionSelectionComponent {

  constructor() { }

}
